VLW.Compenents.ListesVinsElt = class extends VLW.Compenents.IntersectionObjserver {
	constructor(elt) {
		super(elt);
		this.filet = this.elt.querySelector("._filet");
		this.perLine = 5;
		TweenMax.set(this.filet, {scaleX: 0});
		TweenMax.set(this.elt, {opacity: 0});
		this.elt.addEventListener("mouseenter", this.mouseenter);
	}
	
	mouseenter() {
		TweenMax.fromTo(this.filet, .3, {scaleX: 1}, {scaleX: .9, yoyo: true, repeat: 1, ease: Power2.easeInOut});
	}
	
	findColumnIndex() {
		if (this.elt.dataset.columnIndex) {
			return;
		}
		const boundParent            = this.constructor.getBoundParent(this.elt);
		this.perLine                 = 5;
		this.boundX                  = this.elt.getBoundingClientRect().x;
		this.columnIndex             = Math.round(Math.floor(((this.elt.offsetLeft+this.elt.getBoundingClientRect().width*.5 ) / boundParent.width) / (1 / this.perLine)));
		this.elt.dataset.columnIndex = this.columnIndex;
	}
	
	static getBoundParent(elt) {
		return elt.parentNode.getBoundingClientRect();
	}
	
	get threshold() {
		return [0.3];
	}
	
	onIntersectionVisible() {
		window.promiseIntro.then(()=> {
			super.onIntersectionVisible();
			this.findColumnIndex();
			TweenMax.to(this.elt, 1, {opacity: 1, ease: Sine.easeIn});
			TweenMax.to(this.filet, 1, {scaleX: 1, ease: Sine.easeInOut});
			TweenMax.fromTo(this.elt.querySelector("img"), 1, {y: 30}, {y: 0, scaleX: 1, ease: Sine.easeInOut});
		});
		
	}
	
	instanceClean() {
		this.elt.removeEventListener("mouseenter", this.mouseenter);
		this.interSectionObj.disconnect();
		super.instanceClean();
	}
};


